import { forwardRef, type SVGProps } from "react";

/** Angel wings — the Angels (supporters) menu icon (Gordon 2026-10-30: "angels
 *  menu section needs a new icon. angel wings?"). Drawn on lucide's 24px grid
 *  with the same 2px round stroke so it sits with the other menu icons. */
export const AngelWings = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & { size?: number | string }>(
  function AngelWings({ size = 24, className, ...props }, ref) {
    return (
      <svg
        ref={ref}
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
        className={className}
        aria-hidden
        {...props}
      >
        {/* halo */}
        <ellipse cx="12" cy="4" rx="2.5" ry="1" />
        {/* left wing */}
        <path d="M11 9C9 7 5.5 6.5 2 8c1 1.5 2.5 2 4 2-1.5.5-2.5 1.5-3 3 1.8.3 3.5 0 5-1-1 1-1.5 2.5-1.5 4 2-.6 3.5-2 4.5-4" />
        {/* right wing */}
        <path d="M13 9c2-2 5.5-2.5 9-1-1 1.5-2.5 2-4 2 1.5.5 2.5 1.5 3 3-1.8.3-3.5 0-5-1 1 1 1.5 2.5 1.5 4-2-.6-3.5-2-4.5-4" />
        {/* body */}
        <path d="M12 8v12" />
      </svg>
    );
  },
);
